import { LanguageHelper } from './language-helper';

export class LanguageResolver {
    public get currentLanguage(): string {
        return LanguageHelper.resolveCurrentLanguage(window.location.pathname, document.cookie);
    }
}
